import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=72ab5ff3&scoped=true"
import script from "@/controllers/notices.js?vue&type=script&lang=js&external"
export * from "@/controllers/notices.js?vue&type=script&lang=js&external"
import style0 from "./Notices.styles.scss?vue&type=style&index=0&id=72ab5ff3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ab5ff3",
  null
  
)

export default component.exports